export default __webpack_public_path__ + "static/media/micromanager-logo-150.c283b5ef.png";